import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Layout from "@/layout/index.vue";
import teachingPage from "@/views/composition/teachingPage.vue";
import correctPage from "@/views/composition/correctPage.vue";
import pastExamPaper from "@/views/composition/pastExamPaper.vue";
import workHistory from "@/views/composition/workHistory.vue";
import guidePage from "@/views/composition/guidePage.vue";
import polishPage from "@/views/composition/polishPage.vue";
import modelEssay from "@/views/composition/modelEssay.vue";
import sourceMaterial from "@/views/composition/sourceMaterial.vue";
import paySuccess from "@/views/paySuccess.vue";
import writePage from "@/views/composition/writePage.vue";
import sourceMaterialMy from "@/views/composition/sourceMaterialMy.vue";
import store from "@/store/index";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Layout,
    redirect: "/composition/teaching",
    children: [
      {
        path: "/composition/correct",
        name: "correct",
        component: correctPage
      },
      {
        path: "/composition/teaching",
        name: "teaching",
        component: teachingPage
      },
      {
        path: "/composition/pastExamPaper",
        name: "pastExamPaper",
        component: pastExamPaper
      },
      {
        path: "/composition/workHistory",
        name: "workHistory",
        component: workHistory
      },
      {
        path: "/composition/guide",
        name: "guide",
        component: guidePage
      },
      {
        path: "/composition/polish",
        name: "polish",
        component: polishPage
      },
      {
        path: "/composition/modelEssay",
        name: "modelEssay",
        component: modelEssay
      },
      {
        path: "/composition/sourceMaterial",
        name: "sourceMaterial",
        component: sourceMaterial
      },
      {
        path: "/composition/rewrite",
        name: "writePage",
        component: writePage
      },
      {
        path: "/composition/sourceMaterialMy",
        name: "sourceMaterialMy",
        component: sourceMaterialMy
      }
    ]
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component: paySuccess
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, form, next) => {
  store.dispatch("setNowRouter", to.path);
  next();
});

export default router;
